import { useAuthStore } from '@store/authStore';

/**
 * Permission hook: reads permissions from the user context stored in Zustand.
 *
 * Chekit-level permissions come from chekit.permissions[] (resolved by the
 * get_user_context() DB function: union of dept + role + direct grants minus denies).
 *
 * Business-level permissions are per-business in businesses[].permissions[].
 */
export function usePermission() {
  const hasCheKitPermission = useAuthStore((s) => s.hasCheKitPermission);
  const hasBusinessPermission = useAuthStore((s) => s.hasBusinessPermission);
  const hasPermission = useAuthStore((s) => s.hasPermission);

  return { hasPermission, hasCheKitPermission, hasBusinessPermission };
}
